import withUnderReviewText from './withUnderReviewText'
import Preview from 'components/AccountFilePreviewUnderReview'

export default withUnderReviewText(Preview)
